//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import EsQuery from "@/javascript/esQuery";
    import mapUtil from '@/javascript/mapUtil'
    import util from '@/javascript/util'
    import loading from '@/components/public-components/loading/index.vue'
    import { formatDate } from "@/javascript/formatDate"
    import goBack from '@/components/public-components/goBack/index.vue'
    import Footer from "@/components/lyx-components/lyx-footer/index"

    export default {
        components: {

            loading,
            goBack,
            Footer

        },
        data() {
            return {
                minHeight: 0,
                pageNo: 0,
                pageSize: 7,
                location: {},
                dataList: [],
                infiniteStatus: false, //控制加载，true的话停止加载，false的话根据infiniteAll判断
                infiniteAll: false, //在infiniteStatus为false的情况下，infiniteAll为false停止加载，为true继续加载
                isShow: false,
                isWeixin: util.isWeiXin(),
                tabs: [{
                    name: '线路',
                    code: ''
                },{
                    name: '活动',
                    code: ''
                }],
                tabsIndex: 0,
                
            }
        },
        
        mounted() {
            const _this = this
            _this.minHeight = document.documentElement.clientHeight
            document.title = "周边游"

            window.addEventListener("scroll", this.windowScroll);

            this.getSceneryList(0)

            if (localStorage.getItem('peripheral-tab-index') == null) {
                localStorage.setItem('peripheral-tab-index', 0)
            }
            this.tabsIndex = localStorage.getItem('peripheral-tab-index')

        },
       
        methods: {
            tabClick(index) {
                this.tabsIndex = index
                localStorage.setItem('peripheral-tab-index', index)
                this.dataList = []
                this.pageNo = 0
                this.infiniteAll = false
                this.getSceneryList(this.tabsIndex)
            },
            /**
             * @msg: 获取线路和活动
             * @param {*}
             * @return {*}
             */
            getSceneryList(index) {
                const _this = this

                const newsEsQuery = new EsQuery()
                const querystring = require('querystring')
                if (index == 0) {

                    newsEsQuery
                        // .addStartWith("tagNames", "推荐", newsEsQuery.and, false)
                        .addStartWith( "catalogCode", "00000000,1720581749960", newsEsQuery.and, false )
                        .addStartWith( "deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false )
                        .addString("publishStatus", 1, newsEsQuery.asc, false)
                        .addSort("weight", newsEsQuery.desc, false)
                        .addPage(this.pageNo * this.pageSize, this.pageSize)
                    const newsJsList = JSON.stringify(newsEsQuery.getArray())
                    this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                        'indexName': this.INDEX_NAME_TYPE.newsList,
                        'esJsonQuery': newsJsList
                    })).then(res => {
                        let data = []
                        data = res.data.data.map(item => {
                            item._source.createdDate = formatDate(new Date(parseInt(item._source.createdDate)), 'yyyy-MM-dd')
                            return item
                        })

                        _this.dataList = _this.dataList.concat(data)
                        if (res.data.data.length < _this.pageSize) {
                            _this.infiniteAll = true
                        }
                        _this.infiniteStatus = false
                    })
                } else {
                    const catalogCode = "00000000,1721097423388"
                    const catalogId = '36749086e51544e1a1ae567d2b652bcc'

                    newsEsQuery.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
                        .addStartWith("catalogCode", catalogCode, newsEsQuery.and, false)
                        // .addString("top", 0, newsEsQuery.and, false)
                        // .addString("catalogId", catalogId, newsEsQuery.and, false)
                        .addSort("weight", newsEsQuery.desc, false)
                        .addPage(this.pageNo * this.pageSize, this.pageSize)
                    const newsJsList = JSON.stringify(newsEsQuery.getArray())
                    this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                        'indexName': this.INDEX_NAME_TYPE.newsList,
                        'esJsonQuery': newsJsList
                    })).then(res => {
                        let data = []
                        data = res.data.data.map(item => {
                            item._source.createdDate = formatDate(new Date(parseInt(item._source.createdDate)), 'yyyy-MM-dd')
                            return item
                        })

                        _this.dataList = _this.dataList.concat(data)
                        if (res.data.data.length < _this.pageSize) {
                            _this.infiniteAll = true
                        }
                        _this.infiniteStatus = false
                    })

                }
                

                    
            },
            //监听滚动
            windowScroll(e) {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop > 0) {
                    this.isShow = true
                } else {
                    this.isShow = false
                }
                // 底部加载
                if (util.pullUpLoad()) {
                    this.infinite()
                }
            },


            // 初始化分页
            infinite: function () {
                if (this.dataList.length == 0) {
                    return;
                }
                if (this.infiniteAll) {
                    return;
                }
                if (this.infiniteStatus) {
                    return;
                }
                this.infiniteStatus = true;
                this.pageNo += 1;
                this.getSceneryList(this.tabsIndex);
            }
        },
    }
